import * as React from "react";
import ReactDOM from "react-dom";

import { usePopoverContext } from "./PopoverContext";

export const PopoverContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const {
    popoverZIndex,
    showDetached,
    open,
    disableOverflow,
    containingElement,
    bodyRef,
    floatingData,
    floatingInteractions,
  } = usePopoverContext();

  if (!open) {
    return null;
  }

  if (disableOverflow || !bodyRef.current) {
    return children;
  }

  const hidden =
    !showDetached &&
    (floatingData.middlewareData.hide?.escaped ||
      floatingData.middlewareData.hide?.referenceHidden);

  return ReactDOM.createPortal(
    <div
      ref={floatingData.refs.setFloating}
      {...floatingInteractions.getFloatingProps()}
      style={{
        ...floatingData.floatingStyles,
        zIndex: popoverZIndex,
      }}
      hidden={hidden}
    >
      {children}
    </div>,
    containingElement ?? bodyRef.current
  );
};
